/**
 * Static blog posts, deployed with the app, no database needed.
 * The content lives in blogPosts.json so the build scripts (sitemap, prerender,
 * routeMeta sync) can read the same source as the pages. To add a post, append
 * an object to that file. `body` is Markdown, rendered by ReactMarkdown.
 */
import data from './blogPosts.json';

const staticBlogPosts = data.posts;

// Build a lookup map by slug for O(1) access
export const staticPostsBySlug = Object.fromEntries(
  staticBlogPosts.map((p) => [p.slug, p])
);

// Index entries (same shape the listing page expects)
export const staticPostsIndex = staticBlogPosts.map(
  ({ slug, title, excerpt, cover_image, category, published_at, read_time }) => ({
    slug,
    title,
    excerpt,
    cover_image,
    category,
    published_at,
    read_time,
  })
);

export default staticBlogPosts;
